module.exports = __webpack_public_path__ + "static/img/xitongkuangjia (3).2e1d5a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/xitongkuangjia (3).png
// module id = CY6a
// module chunks = 1